<template>
  <div class="relative z-[100] w-full flex justify-center">
    <button 
      @click="toggleMenu" 
      class="relative flex flex-col justify-between w-[22px] h-[20px] lg:w-[25px] bg-transparent border-0 cursor-pointer p-[3px] z-[110]"
    >
      <span class="absolute left-0 top-0 block h-[2px] w-full bg-gray-800"></span>
      <span class="absolute left-0 top-1/2 -translate-y-1/2 block h-[2px] w-full bg-gray-800"></span>
      <span class="absolute left-0 bottom-0 block h-[2px] w-[65%] bg-gray-800"></span>
      <span 
        class="absolute right-0 bottom-0 block h-[2px] w-[25%]"
        :class="{
          'bg-primary-color': !getPrimaryColor,
          [`bg-[${getPrimaryColor}]`]: getPrimaryColor
        }"
      ></span>
    </button>

    <transition name="fade">
      <div v-if="isOpen" class="fixed top-0 left-0 w-full h-full bg-black/90 flex items-center justify-end z-[150]">
        <div class="bg-white w-[100%] max-w-[320px] h-screen overflow-y-auto px-8 py-5">
          <div class="flex border-b border-gray-200 pb-3 items-center mb-10 relative">
            <div class="text-sm font-medium text-gray-800">
              <div>{{ addressPart1 }}</div>
              <div>{{ addressPart2 }}</div>
            </div>
            <button @click="toggleMenu" class="absolute -top-4 right-0 bg-transparent border-0 text-5xl! text-gray-900 cursor-pointer leading-none opacity-70 transition-opacity duration-300 ease-in-out hover:opacity-100">×</button>
          </div>
          <ul class="list-none p-0 m-0 flex flex-col gap-4">
            <li v-for="page in getPages" :key="page.value">
              <a
                v-scroll="{name: page.value, offsetTop: 0}"
                class="flex items-center gap-4 text-lg text-gray-800! no-underline uppercase tracking-wide cursor-pointer"
                @click="clickLink(page)"
              >
                <span 
                  class="w-2 h-2 rotate-45"
                  :class="{
                    'bg-primary-color': !getPrimaryColor,
                    [`bg-[${getPrimaryColor}]`]: getPrimaryColor
                  }"
                ></span>
                <span
                  class="transition-all duration-200 ease-in-out"
                  :class="{
                    'hover:text-[var(--text-primary-color)]': !getPrimaryColor,
                    [`hover:text-[${getPrimaryColor}]`]: getPrimaryColor
                  }"
                >
                  {{ page.label }}
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import gaMixin from '@/shared/mixins/ga';
  import addressMixin from '@/shared/mixins/address';

  export default {
    name: 'PopupMenu',
    mixins: [gaMixin, addressMixin],
    data() {
      return {
        isOpen: false
      }
    },
    computed: {
      ...mapGetters('tour', ['getPages', 'getPrimaryColor']),
    },
    methods: {
      toggleMenu() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
          document.body.classList.add('menu-open');
        } else {
          document.body.classList.remove('menu-open');
        }
      },
      clickLink({ value, label }) {
        this.isOpen = false;
        document.body.classList.remove('menu-open');
        this.$emit('onClickLink', value);
        this.sendEventGA('Page', label);
      }
    },
    beforeDestroy() {
      document.body.classList.remove('menu-open');
    }
  };
</script>

<style lang="scss" scoped>
.active {
  span {
    &:first-child {
      top: 50% !important;
      transform: translateY(-50%) rotate(45deg) !important;
    }
    
    &:nth-child(2) {
      opacity: 0 !important;
    }
    
    &:last-child {
      bottom: 50% !important;
      transform: translateY(50%) rotate(-45deg) !important;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* Style for when menu is open */
:global(body.menu-open) {
  overflow: hidden;
}

/* Adjust menu button size on mobile */
@media (max-width: 1024px) {
  .w-\[25px\].h-\[20px\] {
    width: 20px !important;
    height: 16px !important;
  }
  
  .p-\[3px\] {
    padding: 2px !important;
  }
}
</style> 
